import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[40%] flex flex-col gap-6">
            <div>
              <Link to="/" className="flex items-center gap-2 cursor-pointer group mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-lg text-background-50 dark:text-foreground-950"></i>
                </div>
                <span className="text-xl font-bold font-heading text-background-50 dark:text-foreground-950">
                  91爆料网
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed max-w-md">
                全网热门91爆料视频每日实时追踪，为你深度挖掘网红反转黑料与娱乐圈最新大事件。作为吃瓜群众的核心阵地，第一时间解锁精彩爆点。
              </p>
            </div>

            <div>
              <p className="text-xs text-foreground-500 mb-3 font-medium">订阅每日爆料推送</p>
              <form
                data-readdy-form
                className="flex flex-col sm:flex-row gap-2"
                action="https://readdy.ai/api/form/d92g4pr8srkha17lok70"
                method="POST"
                onSubmit={function(e) {
                  const form = e.currentTarget;
                  const honeypot = form.querySelector('[name="phone_alt"]') as HTMLInputElement;
                  if (honeypot && honeypot.value.trim()) {
                    e.preventDefault();
                    const statusEl = form.querySelector('.subscribe-status');
                    if (statusEl) statusEl.textContent = '订阅成功！感谢关注。';
                    return;
                  }
                }}
              >
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="spam-field"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="输入你的邮箱地址"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-600 text-sm text-foreground-200 placeholder:text-foreground-500 py-2 px-1 outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap px-5 py-2 border border-foreground-500 text-sm text-foreground-300 rounded-md hover:border-primary-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  订阅
                  <i className="ri-arrow-right-line ml-1"></i>
                </button>
                <span className="subscribe-status text-xs text-accent-400 mt-1 sm:mt-0 sm:self-center"></span>
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="text-sm font-semibold text-background-50 dark:text-foreground-950 mb-4">热门分类</p>
              <div className="flex flex-col gap-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <p className="text-sm font-semibold text-background-50 dark:text-foreground-950 mb-4">关于我们</p>
              <div className="flex flex-col gap-3">
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">品牌介绍</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">口碑评价</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">商务合作</Link>
              </div>
            </div>
            <div>
              <p className="text-sm font-semibold text-background-50 dark:text-foreground-950 mb-4">关注我们</p>
              <div className="flex flex-col gap-3">
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line mr-1"></i>微博
                </a>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line mr-1"></i>微信公众号
                </a>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                  <i className="ri-tiktok-line mr-1"></i>抖音
                </a>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line mr-1"></i>B站
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 91爆料网 版权所有 | 全网独家吃瓜黑料第一站
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}